export enum UnauthorizedTypes {
  InvalidCredentials = 1,
  TokenExpired = 2,
  AccessDenied = 3,
}

export enum PermissionsList {}
